import React from "react";
import HeroSection from "../components/HeroSection";
import ComparisonSection from "../components/ComparisonSection";
import CompatibilitySection from "../components/CompatibilitySection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import { Gift, Wrench, Zap, Settings, ShieldCheck } from "lucide-react"; // Ikonky pro banner

const HomePage = ({ navigateTo }) => {
  return (
    <div className="w-full">
      <HeroSection navigateTo={navigateTo} />
      <ComparisonSection />
      <CompatibilitySection navigateTo={navigateTo} />
      
      {/* --- BANNER NA KONFIGURÁTOR (Přesně podle tvého obrázku) --- */}
      <section className="py-16 px-4">
        <div className="bg-gradient-to-br from-green-50 to-[#e6f7ed] rounded-3xl p-8 md:p-12 border border-green-100 shadow-sm text-left max-w-5xl mx-auto relative overflow-hidden flex flex-col md:flex-row items-center gap-8">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 transform translate-x-1/2 -translate-y-1/2"></div>

          <div className="flex-1 z-10">
            <div className="flex items-center gap-3 mb-4">
              <span className="bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide flex items-center gap-1">
                <Gift className="w-3 h-3" /> Akce
              </span>
              <span className="text-green-800 font-semibold text-sm">
                Pro všechny kompletní sady
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-[#2a3b4c] mb-4 leading-tight">
              Nevíte si rady s výběrem komponentů?
            </h2>

            <p className="text-slate-600 mb-6 text-lg leading-relaxed">
              Náš chytrý pomocník vás krok za krokem provede výběrem. Vyberete
              si motor, baterii i displej přesně na míru vašemu kolu.
            </p>

            <button
              onClick={() => navigateTo("products")} // Tohle ho hodí do E-shopu na konfigurátor
              className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-extrabold text-lg rounded-xl shadow-lg transition transform hover:scale-105 inline-flex items-center gap-2"
            >
              <Wrench className="w-5 h-5" /> Sestavit sadu na míru
            </button>
          </div>

          <div className="w-full md:w-1/3 flex flex-col gap-3 z-10 shrink-0">
            <h3 className="font-bold text-green-900 uppercase text-sm tracking-wider mb-1 ml-2">
              Obsah sady
            </h3>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 flex items-center gap-4">
              <div className="p-2 bg-slate-50 rounded-lg"><Zap className="w-6 h-6 text-yellow-500" /></div>
              <span className="font-bold text-[#2a3b4c] text-lg">Motor</span>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 flex items-center gap-4">
              <div className="p-2 bg-slate-50 rounded-lg"><Zap className="w-6 h-6 text-yellow-500" /></div>
              <span className="font-bold text-[#2a3b4c] text-lg">Baterie</span>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 flex items-center gap-4">
              <div className="p-2 bg-slate-50 rounded-lg"><Settings className="w-6 h-6 text-blue-500" /></div>
              <span className="font-bold text-[#2a3b4c] text-lg">Displej</span>
            </div>
            <div className="bg-green-600 p-4 rounded-xl shadow-lg border border-green-500 flex items-center gap-4 mt-2 transform hover:scale-[1.02] transition-transform relative overflow-hidden">
              <div className="absolute top-0 right-0 w-16 h-16 bg-white opacity-10 rounded-full -mr-8 -mt-8"></div>
              <div className="p-2 bg-green-500 rounded-lg"><ShieldCheck className="w-6 h-6 text-white" /></div>
              <div className="flex flex-col">
                <span className="font-black text-yellow-300 uppercase text-xs tracking-wider">Dárek zdarma</span>
                <span className="font-bold text-white text-lg">Brzdový systém</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ------------------------------------------------------------- */}
      
      <TestimonialsSection />
      <FAQSection />
    </div>
  );
};

export default HomePage;